import { useGetBranchesFeesApi } from 'api/packages/query';
import { Fees } from 'constants/enums/general';
import { useFormContext } from 'react-hook-form';

const useGetKeyPickUpFee = () => {
  const { watch } = useFormContext();

  const { data } = useGetBranchesFeesApi(watch('branchId'), watch('keyPickup'));

  const pickUpKeyPrice = data?.reduce(
    (total, fee) => (fee.type === Fees.KEY_PICKUP ? total + fee.price * fee.quantity : total),
    0
  );
  const getKeyPickUp = data?.find(fee => fee?.type === Fees.KEY_PICKUP);

  return {
    price: pickUpKeyPrice ?? 0,
    name: getKeyPickUp?.name ?? '',
    quantity: getKeyPickUp?.quantity ?? 1,
  };
};

export default useGetKeyPickUpFee;
